import useFirebaseStore from "../store/firebasestore";
import useGenStore from "../store/genstore";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react";

function ClearedOrders(){
          const setOrderPopUp = useGenStore((s)=>s.setOrderPopUp)
        const setOrderStatusOnView = useGenStore((s)=>s.setOrderStatusOnView)
        const setOrderOnView = useGenStore((s)=>s.setOrderOnView)
            const clearedOrders = useFirebaseStore((s)=>s.clearedOrders)
            const adminOrders = useFirebaseStore((s)=>s.adminOrders)
   const showOrderPop = (orderId,status) =>{
            setOrderPopUp(true)
            setOrderOnView(orderId)
            setOrderStatusOnView(status)
        }
     const showDelivery = (id) => {
       const sltOrder = clearedOrders.find(order => order.id === id);
   
       if (!sltOrder) {
           Swal.fire({
               title: "Order not found",
               icon: "error"
           });
           return;
       }
   
       Swal.fire({
           title: sltOrder.destination,
           text: sltOrder.delText,
           icon: "info",
           showConfirmButton: true,
           confirmButtonText: "Ok",
           showCancelButton: false,
           cancelButtonColor: "#6a5acd"
       });
   };
                


    return (
        <div className="clearedOrders">
 <div className="orderTableTop">
                        <div className="clientName">
                            <p>Client</p>
                        </div>
                        <div className="orderAmount">
                            <p>Amount</p>
                        </div>
                        <div className="orderDate">
                            <p>Date</p>
                        </div>
                        <div className="orderAction">
                            <p>Action</p>
                        </div>
                    </div>
                    <div className="orderTableBtm">
                       {clearedOrders.map((order,index)=>(
   <div
   key={order.id}

   className="orderTableRow">
<div className="clientName">
    <p >{order.userName}</p>
  
</div>
                        <div className="orderAmount">
                            <p>Ksh. {order.amount}</p>
                        </div>
                        <div className="orderDate">
                            <p>{order.date}</p>
                        </div>
                        <div className="orderAction">
                            <button onClick={()=>showOrderPop(order.id,order.status)}>Check</button>
                            <div className="orderActionIcon">
                                <Icon onClick={()=>showDelivery(order.id)} icon="solar:map-point-bold" className="faIcon"/>
                            </div>
                        </div>
                        </div>
                        ))}
                         
                    </div>
        </div>
    )
}

export default ClearedOrders;